import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PendingActionResponseDto,
  SigninSubmitRequest,
  LoginResponseDto,
} from 'sham-components/shared/models/auth';
import { AppEnvironment } from './core/app-environment';

@Injectable({
  providedIn: 'root',
})
export class SigninApi {
  private readonly http = inject(HttpClient);
  private readonly appEnv = inject(AppEnvironment);

  signinSeller(payload: SigninSubmitRequest): Observable<PendingActionResponseDto> {
    return this.http.post<PendingActionResponseDto>(
      `${this.appEnv.API_BASE_URL()}/v1/auth/signin/seller`,
      payload,
    );
  }

  login(payload: SigninSubmitRequest): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${this.appEnv.API_BASE_URL()}/v1/auth/login`,
      payload,
    );
  }

  refreshToken(payload: { refreshToken: string }): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${this.appEnv.API_BASE_URL()}/v1/auth/refresh-token`,
      payload,
    );
  }
}
